import { create } from "zustand";

type User = {
  id: string;
  name: string;
  avatarUrl?: string;
  permissions: string[];
  preferences?: Record<string, unknown>;
};

type GlobalState = {
  user?: User;
  setUser: (user: User) => void;
  clearUser: () => void;
  // Adicione outros estados globais conforme necessário
};

export const useGlobalStore = create<GlobalState>((set) => ({
  user: undefined,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: undefined }),
}));